const hasMainOrOtherAreas = (sw: any) =>
  (sw?.areas?.length ?? 0) > 0 || (sw?.otherAreas?.length ?? 0) > 0;

export const sectorValidator = (sectorWorkflow: any) => {
  const sectorValidations = {
    categories: !!sectorWorkflow?.category?.uid,
    "type-of-places": !!sectorWorkflow?.places?.uid && !!sectorWorkflow?.squareft,
    "type-of-service": !!sectorWorkflow?.service?.uid,
    areas: hasMainOrOtherAreas(sectorWorkflow),
    objects: true, // No importa es opcional
    "special-requests": true, // Opcional
  };

  return sectorValidations[sectorWorkflow?.step] || false;
};
